import { render } from "./SlidesTutorialCard.vue?vue&type=template&id=7d8ee604&scoped=true"
import script from "./SlidesTutorialCard.vue?vue&type=script&lang=js"
export * from "./SlidesTutorialCard.vue?vue&type=script&lang=js"

import "./SlidesTutorialCard.vue?vue&type=style&index=0&id=7d8ee604&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8ee604"]])

export default __exports__